module.exports = __webpack_public_path__ + "static/media/symphoni-nav.814e451a.png";